<template>
    <div
        class="bg-cover bg-center bg-no-repat px-3 sm:px-6 py-12 z-10"
        :style="{
            backgroundImage: `url('${require('@/assets/img/fondos_pinguiigluu.jpg')}')`
        }"
    >
        <div
            class="flex flex-col items-center w-full max-w-screen-sm mx-auto border-2 border-orange py-10 bg-white"
        >
            <logo class="mb-10"></logo>

            <brush-stroke-bg :variant="2" class="mb-10">
                <h2 class="font-primary text-white text-3xl px-16">
                    {{ $config("CONTACT") }}
                </h2>
            </brush-stroke-bg>

            <ValidationObserver v-slot="{ handleSubmit }" class="w-full">
                <form
                    class="flex flex-col items-center w-3/4 mx-auto"
                    @submit.prevent="handleSubmit(contact)"
                    autocomplete="on"
                    novalidate
                >
                    <form-input
                        name="name"
                        v-model="name"
                        :placeholder="$config('NAME')"
                        class="w-full mb-10"
                        required
                    ></form-input>

                    <form-input
                        name="email"
                        type="email"
                        v-model="email"
                        :placeholder="$config('EMAIL')"
                        class="w-full mb-10"
                        required
                    ></form-input>

                    <text-area-input
                        name="message"
                        v-model="message"
                        :placeholder="$config('MENSAJE')"
                        class="w-full mb-16"
                        required
                    ></text-area-input>

                    <btn
                        class="bg-orange text-white text-xl rounded-large px-10 mb-10"
                    >
                        {{ $config("ENVIAR") }}
                    </btn>
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import requestWithInteractions from "../mixins/requestWithInteractions";
import Logo from "../components/Logo";
import BrushStrokeBg from "../components/BrushStrokeBg";
import FormInput from "../components/FormInput";
import TextAreaInput from "../components/TextAreaInput";
import Btn from "../components/Btn";
import api from "../api";

export default {
    name: "contact",

    components: { Logo, BrushStrokeBg, FormInput, TextAreaInput, Btn },

    mixins: [requestWithInteractions],

    data() {
        return {
            name: "",
            email: "",
            message: ""
        };
    },

    computed: {
        ...mapGetters(["registerOrHomeRoute"])
    },

    methods: {
        contact() {
            this.sendRequest(api.contact(this.name, this.email, this.message), {
                beforeSendText: this.$config("SEND_MESSAGE"),
                successText: this.$config("SENDED_MESSAGE"),
                onSuccess: () => {
                    this.$router.push({ name: "home" });
                }
            });
        }
    }
};
</script>
